module.exports = __webpack_public_path__ + "static/media/国泰君安APP.3fdeaa9.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/国泰君安APP.mp4
// module id = qmDl
// module chunks = 3